import * as types from 'types/socket';

export const disconnectSocket = () => ({
  type: types.DISCONNECT_SOCKET,
});
